import { KycAnalyzeFailedIllustration } from '../../../../../assets/illustrations';
import { WarningIcon } from '../../../../../assets/icons/common';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import Button from '../../../../../components/Button';
import styles from './style.module.scss';

interface Props {
    loading: boolean;
    onRetry: () => void;
};

/** The answers are safely uploaded, but the interview itself could not be handed in. */
function SubmitFailed(props: Props) {
    const { loading, onRetry } = props;

    return (
        <MotionWrapper className={styles.wrapper}>
            <KycAnalyzeFailedIllustration />
            <span className={styles.title}>We couldn't submit your interview</span>
            <div className={styles.description}>
                <WarningIcon />
                <span>
                    Your answers are recorded and safe. Please try sending them again.
                </span>
            </div>
            <Button
                type='Primary'
                text='Try again'
                loading={loading}
                onClick={onRetry}
                className={styles.retry}
            />
        </MotionWrapper>
    )
};

export default SubmitFailed;
